import { render, staticRenderFns } from "./claimFundTypes.vue?vue&type=template&id=f9d67810"
import script from "./claimFundTypes.vue?vue&type=script&lang=js"
export * from "./claimFundTypes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports